"use client";

import React from "react";
import Hero from "../home/Hero";

export const HeroSection: React.FC = () => {
  return <Hero />;
};

export default HeroSection;